export class PopAlertConfig {

}
